import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 团队列表
 * @param params
 * 
*/

export const teamList = params => Http.get(`${baseUrl}/team`, { params })

/**
 * 编辑团队
 * @param params
 * 
*/

export const editTeam = params => Http.put(`${baseUrl}/team`, params )

/**
 * 创建团队
 * @param params
 * 
*/

export const addTeam = params => Http.post(`${baseUrl}/team`, params )

/**
 * 删除团队
 * @param id
 * 
*/

export const delTeam = id => Http.delete(`${baseUrl}/team/${id}` )

/**
 * 团队成员列表
 * @param params
 * 
*/

export const memberList = params => Http.get(`${baseUrl}/team/user`, { params })

/**
 * 删除团队成员
 * @param id
 * 
*/

export const delTeamMember = id => Http.delete(`${baseUrl}/team/user/${id}` )

/**
 * 提升为队长
 * @param teamUserId
 * 
*/

export const upCaptain = teamUserId => Http.put(`${baseUrl}/team/user/${teamUserId}/captain` )

/**
 * 排序
 * @param params
 * 
*/

export const sortTeam = params => Http.put(`${baseUrl}/team/sort`, params )

/**
 * 抖音列表
 * @param params
 * 
*/

export const tiktokList = params => Http.get(`${baseUrl}/team/douyin`, { params } )

/**
 * 快手列表
 * @param params
 * 
*/

export const kuaishouList = params => Http.get(`${baseUrl}/team/kuaishou`, { params } )
